import { render, staticRenderFns } from "./WTS.vue?vue&type=template&id=3dc12afc&"
import script from "./WTS.vue?vue&type=script&lang=js&"
export * from "./WTS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports